<template>
  <div class="kw_tree_list" v-loading="!hasLoaded">
    <el-button-group v-if="treeType==0">
        <el-button type="primary" size="mini" icon="el-icon-refresh" @click="loadDataInfo"></el-button>
        <el-button type="primary" size="mini" icon="el-icon-circle-plus" @click="leftTreeOpen"></el-button>
        <el-button type="primary" size="mini" icon="el-icon-remove" @click="leftTreeClose"></el-button>
    </el-button-group>
    <el-tree v-if="refreshLoaded"
        :data="leftTreeData" 
        :props="leftTreeDefaultProps" 
        @node-click="treeNodeClick"
        @check="treeBoxClick"
        :filter-node-method="filterNode"
        :default-expand-all="leftTreeIfOpen"
        :show-checkbox="dataMaxNum==1?false:true"
        :check-strictly="ifChooseChild==1?false:true"
        node-key="id"
        highlight-current
        ref="oneTree"
    >
      <div slot-scope="scope">
        <span :class="'ztree_image ' + (scope.data.children?'ztree_image_position1':'ztree_image_position2')"></span>
        <span class="ztree_span">{{scope.data.name}}</span>
      </div>
    </el-tree>
    <el-input size="mini"
        placeholder="输入关键字进行过滤"
        v-model="filterText">
    </el-input>
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_tree_list',
  props: {
    initPageObj:{
      type:Object,
      default:null
    },
    //主页面的数据主键
    mainId:{
      default:null
    },
    // 上级页面的下标信息
    parentTabIndex:{
      type: Number,
      default: null
    },
    ifShowSearch:{
      type: Number,
      default: 0
    },
    /**
     * 树类型 0：左侧树  1：下拉树
     */
    treeType:{
      type: Number,
      default: 1
    },
    //是否父子级关联选中 默认为是
    ifChooseChild:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      // 访问来源 PC:2 或者 H5:3
      visitSource:utils.checkVisitSource(),
      // 是否显示加载中的状态
      hasLoaded:false,
      refreshLoaded:true,
      //对象ID
      tableId:0,
      //页面ID
      pageId:0,
      //页面的穿透类型
      ctType:-1,
      //是关联穿透页面时,传递的页面主键
      SourceDataId:null,
      //如果是弹出层时,获取的关联搜索条件
      tmpJsonData:null,
      //主页面的tableId
      mainTableId:0,
      //主页面的pageId
      mainPageId:0,
      //需要默认选中的值
      initCheckId:null,
      //如果是弹出层 需要的选中个数
      dataMaxNum:0,
      //页面数据信息
      pageDataInfo:[],
      //树形结构是否展开
      leftTreeIfOpen:false,
      //树形结构的数据
      leftTreeData:[],
      //树形结构的展示字段名称设置
      leftTreeDefaultProps:{
          children: 'children',
          label: 'name'
      },
      //树形结构的搜索框的搜索值
      filterText:"",
      //当前点击过的值
      nowCheckOneId:0,
      
    };
  },
  created() {
    var that = this;
    var that = this;
    var initPageObj = that.initPageObj;
    if (initPageObj) {
      that.tableId = initPageObj.tableId;
      that.pageId = initPageObj.pageId;
      that.mainTableId = initPageObj.mainTableId ? initPageObj.mainTableId:null;
      that.mainPageId = initPageObj.mainPageId?initPageObj.mainPageId:null;
      that.initCheckId = initPageObj.initCheckId?initPageObj.initCheckId:'';
      that.dataMaxNum = (initPageObj.dataMaxNum || initPageObj.dataMaxNum==0) ? initPageObj.dataMaxNum:0;
      that.tmpJsonData = initPageObj.tmpJsonData ? initPageObj.tmpJsonData:'';
      that.ctType = initPageObj.ctType ? initPageObj.ctType:-1;
      that.SourceDataId = initPageObj.SourceDataId ? initPageObj.SourceDataId:null;
      console.log("initPageObj==========1111111=========",initPageObj,that.initCheckId);
    }
    //进行树数据的加载
    that.loadDataInfo();
  },
  mounted() {
    
  },
  watch:{
    filterText(val) {
      this.$refs.oneTree.filter(val);
    }
  },
  computed:{
  },
  components: {
  },
  methods: {
    /**
     * 去后台进行数据加载
     */
    loadDataInfo(){
      var that = this;
      var pageDataInfo = [];
      var pageSetInfo = that.pageSetInfo;
      var toHtData = {};
      //tableId 表id
      toHtData.tableId = that.tableId;
      //pageId 页面id
      toHtData.pageId = that.pageId;

      if (that.mainId > 0) {
        toHtData.mainId = that.mainId;
      }
      
      // 进行后台数据加载时,进行一些相关参数的逻辑处理
      that.loadDataSearchHandle(toHtData);
      var ajaxListUrl = 'treeDialog_ajaxList.do';
      utils.request(that,{
        url: ajaxListUrl, //读取列表数据的接口
        data: toHtData,
        success: function (res) {
          //赋值当前页的数据进行页面显示
          //进行页面数据处理 组合成为树形结构
          var tmpTrr = pageUtils.buildTree(res.data);
          that.leftTreeData = tmpTrr;
          that.hasLoaded = true;
          console.log("that.initCheckId===================",that.initCheckId);
          if(that.initCheckId != null && that.initCheckId.length > 0) {
            var initCheckKeyArr = that.initCheckId.split(",");
            that.$refs.oneTree.setCheckedKeys(initCheckKeyArr);
          } else {
            if(that.treeType==0) {
              //调用父级的列表搜索方法
              that.$emit('dialogClickCallBack','');
            }
          }
        },
        fail: function () {
          //数据加载失败提示
          that.$notify.error({
            title: '失败',
            message: '数据加载失败，请重试！',
            duration: 2000
          });
        }
      })
    },
    /**
     * 进行后台数据加载时,进行一些相关参数的逻辑处理
     */
    loadDataSearchHandle(toHtData){
      var that = this;
      //ctType=-1 报表或者消息穿透页面类型 暂时默认为 -1 之后如果做报表穿透再启用
      toHtData.ctType = that.ctType;
      //SourceDataId 报表或者消息 穿透页面的过滤条件
      var SourceDataId = that.SourceDataId;
      if (SourceDataId != null) {
        toHtData.SourceDataId = SourceDataId;
      }

      //isOnlyCount  是否只查询记录数
      toHtData.isOnlyCount = false;
      // 判断是否有全局过滤主键条件 如果有则进行valuePlug的传递绑定
      if(localStorage.globalLookIdJson) {
        var globalLookIdJson = JSON.parse(localStorage.globalLookIdJson);
        if (globalLookIdJson) {
          for (var key in globalLookIdJson) {
            var tmpPageId = globalLookIdJson[key].pageId;
            var tmpMainId = globalLookIdJson[key].mainId;
            toHtData["valuePlug_" + tmpPageId] = tmpMainId;
          }
        }
      }

      //判断是否需要把 弹出层的过滤条件 tmpJsonData 传递到后台
      var tmpJsonData = that.tmpJsonData;
      // console.info("tmpJsonData====================" + tmpJsonData);
      if (tmpJsonData != null && tmpJsonData.length > 0) {
        var toHtArr = tmpJsonData.split("!");
        for (var i = 0; i < toHtArr.length; i++) {
          var oneArr = toHtArr[i].split("#");
          if (oneArr.length > 1) {
            toHtData[oneArr[0]] = oneArr[1];
          }
        }
      }


      //是否是列表加号展开页面或者关联选项卡
      var mainId = that.mainId;
      var mainTableId = that.mainTableId;
      var mainPageId = that.mainPageId;
      if (mainId > 0 || mainTableId > 0) {
        toHtData.mainId = mainId;
        toHtData.mainTableId = mainTableId;
        toHtData.mainPageId = mainPageId;
      }

      //判断是否需要把 当前选中 也就是排序 传递到后台
      var initCheckId = that.initCheckId;
      if (initCheckId != null && initCheckId.length > 0) {
        toHtData.orderDataId = initCheckId;
      }
    },
    /**
     * 左侧树点击时去后台进行数据搜索
     */
    treeNodeClick(data,node,tree){
      var that = this;
      console.log("this.dataMaxNum===========",this.dataMaxNum,node);
        if(this.dataMaxNum == 1) {
          if(this.treeType == 0) {
              //左侧树点击时触发父级的列表搜索按钮
              this.nowCheckOneId = data.id;
              //调用父级的列表搜索方法
              this.$emit('dialogClickCallBack',this.nowCheckOneId);
          } else if(this.treeType == 1) {
            var detail = {};
            //下拉树点击时触发树的选中回调
            //当前勾选的，再次勾选时 清空数据
            if(that.initCheckId != null && that.initCheckId.length > 0 && that.initCheckId == node.data.id) {
              detail.checkDataInfo = [];
              detail.val = '';
            } else {
              detail.checkDataInfo = [node.data];
              detail.val = node.data.id;
            }
            this.$emit('dialogClickCallBack', detail);
            //隐藏树的显示 
            this.$emit('openTree');
          }
        } else {
          if(node.checked) {
            node.checked = false;
          } else {
            // var nowCheckKeys = this.$refs.oneTree.getCheckedKeys();
            // nowCheckKeys.push(node.key);
            // this.$refs.oneTree.setCheckedKeys(nowCheckKeys);
            node.checked = true;
          }
          var checkNode = {};
          checkNode.checkedKeys = this.$refs.oneTree.getCheckedKeys();
          checkNode.checkedNodes = this.$refs.oneTree.getCheckedNodes();
          this.treeBoxClick(node,checkNode);
        }
    },
    /**
     * 展开所有的树形节点
     */
    leftTreeOpen() {
        this.leftTreeIfOpen = true;
        let treeList = this.leftTreeData;
        for (let i = 0; i < treeList.length; i++) {
          this.$refs.oneTree.store.nodesMap[treeList[i].id].expanded = true
        }
        // this.refreshLoaded = false;
        // this.$nextTick(function(){
        //   this.refreshLoaded = true;
        // })
    },
    /**
     * 收起所有的树形节点
     */
    leftTreeClose() {
        this.leftTreeIfOpen = false;
        let treeList = this.leftTreeData;
        for (let i = 0; i < treeList.length; i++) {
          this.$refs.oneTree.store.nodesMap[treeList[i].id].expanded = false
        }
        // this.refreshLoaded = false;
        // this.$nextTick(function(){
        //   this.refreshLoaded = true;
        // })
    },
    /**
     * 进行树形节点的搜索
     */
    filterNode(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
    },
    treeBoxClick(node,checkNode) {
        //checkedNodes 
        //判断是否 已经达到要求选择的个数 如果大于要求选择个数
        if(checkNode.checkedKeys.length > this.dataMaxNum && this.dataMaxNum > 0) {
            this.$message({
                message: '最多可以选中'+this.dataMaxNum+"个!",
                type: 'warning'
            });
            var nowCheckedKeys = checkNode.checkedKeys;
            nowCheckedKeys.splice(nowCheckedKeys.length-1);
            this.$refs.oneTree.setCheckedKeys([]);
        } else {
          var detail = {};
          detail.checkDataInfo = checkNode.checkedNodes;
          var nowCheckId = "";
          checkNode.checkedNodes.forEach(element => {
            nowCheckId += (nowCheckId != ""?",":"") + element.id;
          });
          detail.val = nowCheckId;
          this.$emit('dialogClickCallBack', detail);
        }
    },
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ztree_image {
    line-height: 0;
    margin: 0 0 3px 0;
    width: 16px;
    height: 16px;
    display: inline-block;
    vertical-align: middle;
    border: 0 none;
    cursor: pointer;
    outline: none;
    background-color: transparent;
    background-repeat: no-repeat;
    background-attachment: scroll;
    background-image: url("./img/zTreeStandard-new.png");
}
.ztree_image_position1 {
    background-position: -110px 0;
}
.ztree_image_position2 {
    background-position: -110px -32px;
}
.ztree_span{
  margin: 0 0 0 3px;
}
</style>
